import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6de69ed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "value" }
const _hoisted_3 = ["onClick"]

import CommonStore from "@/store/modules/common";
import { timeFormat, contentTextLength } from "@/utils/utilsHandle";
import { computed, getCurrentInstance, nextTick, onMounted, ref, watch } from "vue";
interface IList {
  label: string;
  value: any;
  type: string;
  selections: [];
  hide: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  dynamicMap: Object,
  templateCode: {
    type: Object,
    default: null,
  },
  entity: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props

const { proxy } = getCurrentInstance() as any;

const MAS_TEMPLATE_CODE_TRUE = "MAS_TEMPLATE_CODE_TRUE";
const stateList = ref<IList[]>([]);

const dynamicInfo = computed(() => {
  return proxy?.$stores.retrieveStore(CommonStore).getDynamicMapInfo;
});

const getDynamicMap = (dynamicMap: any) => {
  if (!dynamicMap) {
    dynamicMap = {};
  }
  let arr: any[] = [];
  if (!dynamicInfo.value[props.entity]?.properties) return false;
  let filterFlag = props.templateCode && props.templateCode !== null ? true : false;
  if (
    dynamicInfo.value[props.entity].properties &&
    dynamicInfo.value[props.entity].properties?.length
  ) {
    dynamicInfo.value[props.entity].properties
      .filter(
        (x: any) =>
          (filterFlag ? x.templateCode === props.templateCode : !x.templateCode) &&
          !x.disabled
      )
      .forEach((x: any) => {
        let obj = {};
        if (!x.disabled) {
          if (x.selections?.length) {
            obj = {
              label: x.displayName,
              value: String(dynamicMap[x.name]),
              type: x.displayType,
              selections: x.selections,
              hide: true,
            };
          } else {
            obj = {
              label: x.displayName,
              value: dynamicMap[x.name],
              type: x.displayType,
              selections: x.selections,
              hide: true,
            };
          }
          if (JSON.stringify(obj) !== "{}") {
            arr.push(obj);
          }
        }
      });
  }

  stateList.value = arr;
};
const setMulti = (value: string, selections: any[]) => {
  // 设置除了date以外的label值
  let str = "";
  if (selections?.length) {
    if (value && value !== "undefined") {
      let arr = value.split(",");
      if (arr.length > 1) {
        selections.forEach((x: any) => {
          if (arr.indexOf(x.value) !== -1) {
            str += x.label + ",";
          }
        });
      } else {
        str = selections.filter((x: any) => String(x.value) === value)[0].label || "";
      }
    }
  } else {
    str = value;
  }
  return str || "-";
};

watch(
  () => props.dynamicMap,
  () => {
    getDynamicMap(props.dynamicMap);
  }
);
onMounted(() => {
  nextTick(() => {
    getDynamicMap(props.dynamicMap);
  });
});

return (_ctx: any,_cache: any) => {
  return (stateList.value.length)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(stateList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [
          (item.label)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(item.label) + "：", 1),
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(["date", "datetime"].indexOf(item.type) !== -1
              ? _unref(timeFormat)(item.value, 0)
              : item.hide
              ? _unref(contentTextLength)(setMulti(item.value, item.selections), 40)
              : setMulti(item.value, item.selections)) + " ", 1),
                  (setMulti(item.value, item.selections).length > 40)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "openCon",
                        onClick: _withModifiers(($event: any) => (item.hide = !item.hide), ["stop"])
                      }, _toDisplayString(item.hide ? "展开" : "收起"), 9, _hoisted_3))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    : _createCommentVNode("", true)
}
}

})